import React from 'react'
import { connect } from 'react-redux'
import {  Row } from 'react-bootstrap'

import SearchBarDashboard from '../../../components/SearchBarDashboard'
import PropertyTitle from '../../../components/PropertyTitle'
import 'react-toggle/style.css'


import { fetchActiveLicensesPercentageByProductEan } from '../../../actions/product-actions'
import { NO_SEARCH_RESULTS } from '../../messages'

class LicensesActivePerProductEan extends React.Component {

    constructor() {
      super()
      this.state = { query: undefined, isSearching: false }
    }

    componentDidMount() {

      if(this.props.results.ean) {

        this.setState({ query: this.props.results.ean })
      }
    }

    componentWillUnmount() {
      this.setState({ query: undefined })
    }

    search(query) {
      this.setState({ query, isSearching: true })
      this.props.fetchActiveLicensesPercentageByProductEan(query).then(() => {
        this.setState({ isSearching: false })
      })
    }

    render() {
        const { results } = this.props
    
        return <div className='content-changeUserId' >
          <Row className='dashboardRowContainer'>
            <PropertyTitle 
              icon='pie-chart' 
              text=" Activatiegraad" 
            />
          <Row >
            <div style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
              <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px"}}>
                Vind het percentage geactiveerde licenties voor een EAN. Vul hieronder de EAN in waarop u wilt zoeken.
                </div>
                <SearchBarDashboard style={{ backgroundColor:"white", padding:"5px",  marginTop:"5px"}}
                placeholder="EAN"
                value={this.state.query || this.props.results.ean}
                callback={(query) => this.search(query)}
                isLoading={this.state.isSearching}
                />
              </div>
          </Row>
          </Row>
          <Row className='dashboardRowContainer'>
            {results?.total? (
            <Row style={{border:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"10px"}}>
               <div style={{borderBottom:"solid", borderWidth:"1px", borderColor:"lightgray", padding:"5px",  marginBottom:"10px", fontWeight:"bold"}}>
                Activatiegraad voor EAN
                </div>
                <div style={{padding:"5px",  textAlign:"center", fontSize:"32px", fontWeight:"bold"}}>
                {results.activePercentage}%
                </div>
            </Row>
            ) : (
              this.state.query && !this.state.isSearching ? <div>{NO_SEARCH_RESULTS}</div> : <div></div>
            ) }
            
          </Row>
        </div>
      }
}


export default connect((state) => { 
    return { 
    results: state.products.licensesActivePercentage,
    query: state.products.licensesActivePercentage.EAN
   }}, {
    fetchActiveLicensesPercentageByProductEan
  })(LicensesActivePerProductEan)